import './index.scss';
import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AiOutlineClose, AiOutlineCheck } from 'react-icons/ai';
import { Modal } from 'src/component/Modal';
import { Select } from 'src/component/Select';
import { ScreenTitle, FlexRow, Button } from 'src/style';
import VisibilityContext from 'src/provider/state-manager/visibilityProvider';
import { Users } from 'src/assets/icon';
import helpers, {
    getAcademicSessions,
    getAllStudentsInClass,
    getClassList,
    getStudentsList
} from 'src/utils/helpers';
import AppInfoContext from 'src/provider/state-manager/appInfoProvider';
import ApiContext from 'src/provider/API/call-service';
import { terms } from 'src/provider/config/constant';
import UserContext from 'src/provider/state-manager/userProvider';
import { MemberTypeEnum } from 'src/model';

export const ViewResultsModal = () => {
    const navigate = useNavigate();
    const { API } = useContext(ApiContext);
    const { user } = useContext(UserContext);
    const { info } = useContext(AppInfoContext);
    const { visibility, setModal, notifier } = useContext(VisibilityContext);
    const [data, setData] = useState({ studentClass: "", studentName: "", session: "", term: "" });

    const classList = getClassList(info);
    const sessions = getAcademicSessions();
    const allStudents = getStudentsList(info);
    const studentList = getAllStudentsInClass(allStudents, data.studentClass);

    useEffect(() => {
        if (user?.profile.memberType === MemberTypeEnum.STUDENT) {
            setData({
                ...data,
                studentClass: user?.profile?.memberClass,
                studentName: user?.profile?.username
            })
        }
    }, [user]);

    const handleCancel = () => {
        setModal({ key: "showViewResults", value: false });
    };

    const handleSubmit = async () => {
        const validation = helpers.inputValidator(data);
        if (!validation.isValidated) return notifier.show(validation.message, 'Validation Response');
        const response = await API.getResult(data);
        if (response) {
            navigate(`/dashboard/view-results`);
            handleCancel();
        };
    };

    const handleSelect = (key: string, value: string) => {
        setData({ ...data, [key]: value })
    };

    return (
        <Modal
            isOnMenu
            className='view-result-modal'
            open={visibility.showViewResults}
            cancel={handleCancel}
        >
            <ScreenTitle
                color='#712126'
                textSize='2'
                bottomMargin='4'
            >
                View Results
            </ScreenTitle>
            {user?.profile.memberType !== MemberTypeEnum.STUDENT ?
                (<Select
                    label='Class'
                    list={classList}
                    name='studentClass'
                    handleSelect={handleSelect}
                    placeholder='Select Member Class'
                />) : null
            }
            {user?.profile.memberType !== MemberTypeEnum.STUDENT ?
                (<Select
                    label='Student'
                    list={studentList}
                    name='studentName'
                    handleSelect={handleSelect}
                    placeholder='Select Student'
                    Icon={<Users />}
                />) : null
            }
            <Select
                name='session'
                label='Session'
                list={sessions}
                handleSelect={handleSelect}
                placeholder='Select Session'
            />
            <Select
                name='term'
                label='Term'
                list={terms}
                placeholder='Select Term'
                handleSelect={handleSelect}
            />

            <FlexRow isMaxWidth>
                <FlexRow topMargin='2' justifyContent='space-between' className='btn-container'>
                    <Button
                        hoverColor='#A77B37'
                        onClick={handleCancel}
                        className='view-result-btn cancel'
                    >
                        <AiOutlineClose size={17} />
                        Cancel
                    </Button>
                    <Button
                        hoverBgColor='#fff'
                        hoverColor='#A77B37'
                        borderColor='#A77B37'
                        onClick={handleSubmit}
                        className='view-result-btn confirm'
                    >
                        <AiOutlineCheck size={17} />
                        Confirm
                    </Button>
                </FlexRow>
            </FlexRow>
        </Modal>
    )
}
